import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Plus, Pencil, Trash2, Star } from "lucide-react";
import { api, apiErr } from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";

export default function AdminBrands() {
  const [rows, setRows] = useState([]);
  const [open, setOpen] = useState(false);
  const [editing, setEditing] = useState(null);
  const [f, setF] = useState({ name: "", logo: "", order: 0, featured: false });

  const load = () => api.get("/admin/brands").then((r) => setRows(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const openNew = () => { setEditing(null); setF({ name: "", logo: "", order: 0, featured: false }); setOpen(true); };
  const openEdit = (b) => { setEditing(b); setF({ name: b.name || "", logo: b.logo || "", order: b.order || 0, featured: !!b.featured }); setOpen(true); };
  const save = async () => {
    try {
      const payload = { ...f, order: Number(f.order) || 0 };
      if (editing) await api.put(`/admin/brands/${editing.id}`, payload);
      else await api.post("/admin/brands", payload);
      toast.success("Saved"); setOpen(false); load();
    } catch (e) { toast.error(apiErr(e)); }
  };
  const del = async (id) => { if (!window.confirm("Delete brand?")) return; try { await api.delete(`/admin/brands/${id}`); toast.success("Deleted"); load(); } catch (e) { toast.error(apiErr(e)); } };

  return (
    <div data-testid="admin-brands">
      <div className="flex items-center justify-between flex-wrap gap-2 mb-4">
        <div><h1 className="text-2xl font-bold">Brands</h1><p className="text-slate-500 text-sm">Manage karo — app ke saath 2-way synced. Featured brands homepage par aayenge.</p></div>
        <button data-testid="admin-brands-add" onClick={openNew} className="px-4 py-2 bg-emerald-600 hover:bg-emerald-700 text-white rounded-lg text-sm font-bold inline-flex items-center gap-1"><Plus size={15} /> Add Brand</button>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3">
        {!rows.length && <p className="col-span-full text-slate-400 text-sm py-8 text-center">Koi brand nahi.</p>}
        {rows.map((b) => (
          <div key={b.id} data-testid={`brand-row-${b.id}`} className="bg-white border border-slate-200 rounded-xl p-3 flex flex-col">
            <div className="h-16 flex items-center justify-center bg-slate-50 rounded-lg mb-2 overflow-hidden">
              {b.logo ? <img src={b.logo} alt={b.name} className="max-h-full max-w-full object-contain" onError={(e) => { e.currentTarget.style.display = "none"; }} /> : <span className="text-slate-300 text-xs">No logo</span>}
            </div>
            <div className="flex items-center gap-1">
              <p className="font-bold text-sm truncate flex-1">{b.name}</p>
              {b.featured && <Star size={13} className="fill-amber-400 text-amber-400 shrink-0" />}
            </div>
            <p className="text-[11px] text-slate-400">Order: {b.order || 0}</p>
            <div className="flex gap-2 mt-2">
              <button data-testid={`brand-edit-${b.id}`} onClick={() => openEdit(b)} className="flex-1 py-1.5 bg-slate-100 hover:bg-slate-200 rounded-lg text-xs font-semibold inline-flex items-center justify-center gap-1"><Pencil size={12} /> Edit</button>
              <button data-testid={`brand-del-${b.id}`} onClick={() => del(b.id)} className="py-1.5 px-2.5 bg-rose-50 hover:bg-rose-100 text-rose-600 rounded-lg"><Trash2 size={13} /></button>
            </div>
          </div>
        ))}
      </div>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="bg-white max-w-md" data-testid="admin-brands-dialog">
          <DialogHeader><DialogTitle>{editing ? "Edit" : "Add"} Brand</DialogTitle></DialogHeader>
          <div className="space-y-3">
            <div><label className="text-xs font-semibold text-slate-500">Brand name</label><input data-testid="brand-f-name" value={f.name} onChange={(e) => setF({ ...f, name: e.target.value })} className="w-full border border-slate-200 rounded-lg px-3 py-2 text-sm mt-1" /></div>
            <div><label className="text-xs font-semibold text-slate-500">Logo URL</label><input data-testid="brand-f-logo" value={f.logo} onChange={(e) => setF({ ...f, logo: e.target.value })} placeholder="https://…" className="w-full border border-slate-200 rounded-lg px-3 py-2 text-sm mt-1" /></div>
            <div className="flex items-center gap-4">
              <div className="flex-1"><label className="text-xs font-semibold text-slate-500">Display order</label><input data-testid="brand-f-order" type="number" value={f.order} onChange={(e) => setF({ ...f, order: e.target.value })} className="w-full border border-slate-200 rounded-lg px-3 py-2 text-sm mt-1" /></div>
              <label className="flex items-center gap-2 text-sm font-semibold text-slate-600 mt-5"><input data-testid="brand-f-featured" type="checkbox" checked={f.featured} onChange={(e) => setF({ ...f, featured: e.target.checked })} /> Featured</label>
            </div>
          </div>
          <button data-testid="admin-brands-save" onClick={save} className="w-full py-2.5 bg-emerald-600 hover:bg-emerald-700 text-white rounded-lg font-bold">Save Brand</button>
        </DialogContent>
      </Dialog>
    </div>
  );
}
